import React, { useEffect } from "react";
import zainLogo from "../../../images/zain-logo.png";
import { useParams  , useNavigate } from "react-router-dom";
import { useStateContext } from "../../../context/contextProvider";
import  Skeleton  from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
const Details = () => {
  const { baseUrl , getOneCompany ,dataOneCompany , dataOneCompanyLoading , dataOneCompanyErrMsg , dataOneCompanyShowErrMsg } = useStateContext();
  let { nameCompany } = useParams();
  //console.log(id);

const nav = useNavigate();

  useEffect( () => {
    window.scrollTo(0, 0);
    const idCompany = sessionStorage.getItem("CompanyId");

    getOneCompany(idCompany);
  
  } , []);
 
  return (
    <div className=" tw-mt-[150px]">
      <div className="tw-w-[80%] sm:tw-w-[95%] tw-mx-auto tw-my-4 tw-p-2">
        <div className={`tw-w-full tw-text-center tw-pb-3 tw-text-red-500 ${dataOneCompanyShowErrMsg === false ? "tw-hidden" : ""}`}>
          {
            dataOneCompanyShowErrMsg &&
            dataOneCompanyErrMsg 
          }
        </div>
        <div className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-group tw-w-[50%] md:tw-w-full tw-text-second-zain tw-font-bold tw-text-xl md:tw-text-lg sm:tw-text-sm tw-py-3 tw-px-2 tw-pr-4 tw-rounded-sm tw-shadow-sm tw-border-r-2 tw-border-second-zain">

          <div className="tw-w-[150px] tw-max-h-[150px] md:tw-w-[100px] md:tw-max-h-[100px] sm:tw-w-[80px] sm:tw-max-h-[100px] tw-overflow-hidden">
           {dataOneCompanyLoading ?  
           <img src={`${baseUrl}${dataOneCompany.image}`} className="tw-w-full tw-h-full tw-object-cover" />
          : 
          <Skeleton width={100} height={100}/>
          } 
          </div>
          <div >
            <h3 className="tw-text-second-zain tw-font-semibold tw-text-2xl lg:tw-text-xl md:tw-text-lg xs:tw-text-sm tw-whitespace-nowrap tw-p-4">
             { dataOneCompanyLoading ?
              dataOneCompany.company_name 
              :
              <Skeleton width={200} height={30}/>
              }
            </h3>
          </div>
        </div>
        <div className=" tw-shadow-md tw-rounded-sm tw-max-h-[600px] tw-overflow-auto tw-p-2 tw-border-gray-50 tw-mt-4 tw-border-t-2 tw-border-t-second-zain">
         {
          dataOneCompanyLoading ?
          <div dangerouslySetInnerHTML={{__html: dataOneCompany.body}} className="tw-text-gray-500 tw-p-3 tc">
          </div>
          :
          <Skeleton count={10} height={15} />
         }
        </div>
      </div>
    </div>
  );
};

export default Details;
